import * as serializer from 'basic-editor-value-serializer';

export default function withVoids(editor) {

  const { isVoid } = editor;

  editor.isVoid = function _isVoid(element) {

    if (serializer.voidElements.indexOf(element.type) !== -1) {
      return true;
    }

    // const properties = element.properties || {};
    // const columnId = properties.columnId;

    // if (typeof columnId === 'string') {
    //   return true;
    // }

    return isVoid(element);

  };

  return editor;

}